module.exports = __webpack_public_path__ + "img/ring_g_i_null_0@2x.3acd1ceb.png";